import axios from "axios";
import { toast } from "@/components/ui/use-toast";

export async function subscribe(email) {
  try {
    const response = await axios.post("/api/subscribe", { email });
    toast({
      title: response?.data?.message,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
}
